/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .partner-info[_ngcontent-%COMP%]{width:130px;height:50px;margin-top:0!important;margin-left:1rem;-ms-flex:0 0 auto;flex:0 0 auto;font-size:1.4rem}[_nghost-%COMP%]   .partner-info[_ngcontent-%COMP%]   .app-svg[_ngcontent-%COMP%]{height:2rem;margin-top:4px}@media (max-width:599px){[_nghost-%COMP%]   .sidebar__info.sidebar__info--columns[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-direction:column-reverse;flex-direction:column-reverse;padding:1.2rem .1rem}}"];
export { styles as styles };
